import { useObserver } from 'mobx-react';

import { useStore } from '@store/index';

export const useTradeStore = () => {
  const { tradeStore } = useStore();
  return useObserver(() => tradeStore)
}
